import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform, NavController } from '@ionic/angular';

import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
// import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx'
import OneSignalPlugin from "onesignal-cordova-plugin"
// import OneSignal from 'plugins/onesignal-cordova-plugin/dist';
// import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';


import { AuthService } from './services/auth.service';
import { UserService } from './services/user.service';
import { AlertService } from './services/alert.service';
import { DeviceService } from './services/device.service';
import { NavigationService } from './services/navigation.service';

import { UserModel } from './models/user.model';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: [
    './side-menu/styles/side-menu.scss',
    './side-menu/styles/side-menu.shell.scss',
    './side-menu/styles/side-menu.responsive.scss'
  ]
})
export class AppComponent {

  public userInfo: UserModel = null;

  appPages$ = this.navigationService.appPages$;
  
  appPages = [{
    title: 'Все устройства',
    url: '/main/devices/0',
    icon: 'apps-outline'
  }]
  accountPages = [
    {
      title: 'Профиль',
      url: '/account/profile',
      icon: 'person-circle-outline',
    },
    {
      title: 'Совместный доступ',
      url: '/account/affiliate',
      icon: 'people-outline',
    },
  ];
  financePages = [
    {
      title: 'Выбрать тариф',
      url: '/finance/tariffs',
      icon: 'cart',
    },
    {
      title: 'Пополнить счет',
      url: '/finance/payments',
      icon: 'cash',
    },
    {
      title: 'Отчеты',
      url: '/finance/reports',
      icon: 'clipboard',
    }
  ];
  otherPages = [
    {
      title: 'Контакты',
      url: '/others/contacts',
      icon: 'mail'
    },
    // {
    //   title: 'Помощь',
    //   url: '/others/help',
    //   icon: 'help-circle-outline'
    // }
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    // public oneSignal: OneSignal,
    private auth: AuthService,
    public  user: UserService,
    private alert: AlertService,
    private device: DeviceService,
    private router: Router,
    private navigationService: NavigationService
    // private googleAnalytics: GoogleAnalytics,
    // private navCtrl: NavController,
  ) {
    this.initializeApp();
  }

  async initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('android')) {
        this.statusBar.styleLightContent();
      } else {
        this.statusBar.styleDefault();
      }
      // if (this.platform.is('desktop')) {
      //   this.googleAnalytics.startTrackerWithId('UA-53443516-1')
      //   .then(() => {
      //     console.log('initializeApp(): Google analytics is ready now');
      //     // the component is ready and you can call any method here
      //     this.googleAnalytics.debugMode();
      //     this.googleAnalytics.setAllowIDFACollection(true);
      //   })
      //   .catch(e => console.error('initializeApp(): Error starting GoogleAnalytics:', e));
      // }
      this.splashScreen.hide();
    });

    const token = await this.auth.getToken();
    if (!token) {
      return;
    }

    try {
      this.userInfo = await this.user.getUserInfo();
      if (!this.userInfo.affiliated   &&
          this.platform.is('mobile')  &&
          this.platform.is('cordova')
          ) {
        this.initializePushNotifications();
      }
    } catch (error) {
      if (error.status === 401) {
        this.userInfo = null;
        this.user.clear();
        this.auth.logout();
        await this.router.navigateByUrl('/auth/login');
      } else {
        console.error('initializeApp(): Error loading user', error);
        this.alert.presentToast('Не удалось загрузить данные пользователя', 'danger');
      }
    }
  }

  // When Logout Button is pressed
  async logout() {
    // console.log('app::logout(): Entering');

    // Remove push notification info from backend
    await this.user.sendPlayerInfo(this.user.playerInfo, 'remove')
    .catch(() => {
      this.alert.presentToast('Ошибка при удалении идентификатора устройства пользователя', 'danger');
    });

    await this.user.clear();
    await this.device.clear();
    await this.navigationService.clearExceptFirst();
    await this.auth.logout();
    await this.router.navigateByUrl('/auth/login');
  }

  initializePushNotifications() {
    console.log('init push');
    OneSignalPlugin.setAppId(environment.oneSignalAppId);
    OneSignalPlugin.getDeviceState((response) => {
      console.log(response.userId);
      console.log(this.user.playerInfo);
      this.user.playerInfo = { userId: response.userId }
      })
      OneSignalPlugin.setNotificationOpenedHandler(function(jsonData) {
          console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
          // this.router.navigateByUrl(
          //         '/main/devices/' + jsonData.additionalData.deviceType + '/' + jsonData.additionalData.deviceId);
  
      });
      OneSignalPlugin.promptForPushNotificationsWithUserResponse(function(accepted) {
          console.log("User accepted notifications: " + accepted);
      });
      
      
    // this.oneSignal
    //   .startInit(environment.oneSignalAppId, environment.googleSenderId)
    //   // .iOSSettings(iosSettings)     // only needed if added Optional OneSignal code for iOS above
    //   .inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.Notification)
    //   .handleNotificationReceived((data: any) => {
    //     // Notifcation was received in general
    //     const msg = data.payload.body;
    //     const title = data.payload.title;
    //     const additionalData = data.payload.additionalData;
    //     // this.showAlert(title, msg, additionalData.task);
    //     this.router.navigateByUrl(
    //       '/main/devices/' + additionalData.deviceType + '/' + additionalData.deviceId);
    //   })
    //   .handleNotificationOpened((data: any) => {
    //     // Notification was really clicked/opened
    //     // Just a note that the data is a different place here!
    //     const additionalData = data.notification.payload.additionalData;
    //     this.router.navigateByUrl(
    //       '/main/devices/' + additionalData.deviceType + '/' + additionalData.deviceId);
    //   })
    //   .endInit();

    // // Then You Can Get Devices ID
    // this.oneSignal.getIds().then(identity => {
    //   // console.log('initializePushNotifications():', identity);
    //   this.user.playerInfo = identity
    //   // this.user.sendPlayerInfo(identity, 'save')
    //   // .catch(() => {
    //   //   this.alert.presentToast('Идентификатор устройства пользователя не сохранен', 'danger');
    //   // });
    // });
  }
}
